import React, { useState, useEffect } from "react"
//import axios from 'axios'
import moment from "moment"

import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import "@fontsource/kanit/300.css"
import "@fontsource/kanit/400.css"
import "@fontsource/kanit/500.css"
import "@fontsource/kanit/700.css"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import Tab from "@mui/material/Tab"
import TabContext from "@mui/lab/TabContext"
import TabList from "@mui/lab/TabList"
import TabPanel from "@mui/lab/TabPanel"
import Paper from "@mui/material/Paper"
import Grid from "@mui/material/Grid"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell, { tableCellClasses } from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import Chip from "@mui/material/Chip"
import {
  Link,
  Button,
  TextField,
  ButtonGroup,
  InputAdornment,
  Tooltip,
} from "@mui/material"
import AdapterDateFns from "@mui/lab/AdapterDateFns"
import LocalizationProvider from "@mui/lab/LocalizationProvider"
import DateTimePicker from "@mui/lab/DateTimePicker"
import FilterIcon from "@mui/icons-material/Sort"
import TelIcon from "@mui/icons-material/Call"
import SearchIcon from "@mui/icons-material/Search"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import ReportProblemIcon from "@mui/icons-material/ReportProblem"
import GpsFixedIcon from "@mui/icons-material/GpsFixed"

import AppApi from "../utils/AppApi"
import TruckMapDialog from "../components/TruckMapDialog"
import EtaHistory from "../components/EtaHistory"

const MA_polygon = [
  [99.57290053367615, 11.210460138532039],
  [99.57228899002075, 11.209439296466764],
  [99.57385540008545, 11.208797321775435],
  [99.57420945167542, 11.209344578978993],
  [99.57617282867432, 11.210039173168662],
  [99.57646250724792, 11.210460138532039],
  [99.57506775856018, 11.211217874641322],
  [99.5740807056427, 11.209965504167053],
  [99.57290053367615, 11.210460138532039],
]

const truckInYardTheme = createTheme({
  typography: {
    fontFamily: '"Kanit", "Roboto", "Helvetica", "Arial", sans-serif',
  },
})

const YARD_polygon = [
  [99.542795419693, 11.23023429536016],
  [99.54397559165955, 11.22913985906864],
  [99.54516649246214, 11.230023827164912],
  [99.54412579536438, 11.23131820413465],
  [99.542795419693, 11.23023429536016],
]

const TruckInYard = () => {
  const [data, setData] = useState([])
  const [eta, setETA] = useState([])
  const [ma, setMA] = useState([])
  const [value, setValue] = React.useState("1")
  const [openDialog, setOpenDialog] = useState(false)
  const [locationData, setLocationData] = useState({ vehicleName: "Dummy" })
  const [location] = useState([100, 100])
  const [currentETA, setCurrentETA] = useState(new Date())
  const [available, setAvailable] = useState(0)
  const [unavailable, setUnavailable] = useState(0)

  useEffect(() => {
    const getData = async () => {
      let response = await AppApi.post("/truck_polygon", {
        polygon: YARD_polygon,
      })

      setData(response.data)

      //update available stat
      let truck_avilable = response.data.filter(
        (truck) =>
          truck.dn[0].status === "discharged" ||
          truck.dn[0].status === "closed"
      ).length

      let truck_unavailable = response.data.filter(
        (truck) =>
          !(
            truck.dn[0].status === "discharged" ||
            truck.dn[0].status === "closed"
          )
      ).length

      setAvailable(truck_avilable)
      setUnavailable(truck_unavailable)

      console.log(moment(currentETA).format())

      let eta = await AppApi.post("/eta", {
        eta_date: moment(currentETA).format(),
      })
      setETA(eta.data)

      let ma_res = await AppApi.post("/truck_polygon", { polygon: MA_polygon })

      setMA(ma_res.data)
    }

    getData()
    const iv = setInterval(getData, 60000)

    return () => clearInterval(iv)
  }, [currentETA])

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const handleClose = () => {
    console.log("handle Close")
    setOpenDialog(false)
  }

  const handleOpen = async (data) => {
    console.log("handle Open", data.truck_no)

    if (typeof data.current_dn === "string") {
      var dn_data = await AppApi.get(`/dn/${data.current_dn}`)
    }

    let response = await AppApi.post("/truck_location", {
      truck_no: data.truck_no,
    })

    let start_date = moment(
      data.current_dn.substring(0, 6),
      "YYMMDD"
    ).toISOString()
    let end_date = moment(data.current_dn.substring(0, 6), "YYMMDD")
      .add(3, "days")
      .toISOString()

    console.log(start_date, end_date)

    let history_data = await AppApi.post("/truck_history", {
      start_date,
      end_date,
      truck_no: data.truck_no,
    })

    let latitude = response.data[0].latitude
    let longitude = response.data[0].longitude
    let address = response.data[0].address
    let speed = response.data[0].speed
    let show_dn =
      response.data[0].dn.length > 10 ? 10 : response.data[0].dn.length
    let dn_list = response.data[0].dn.slice(-1 * show_dn)

    setLocationData({
      vehicleName: data.truck_no,
      latitude,
      longitude,
      address,
      dn_list,
      speed,
      history_data: history_data.data,
      current_dn:
        typeof data.current_dn === "string" ? dn_data.data[0] : data.current_dn,
    })
    setOpenDialog(true)
  }

  return (
    <ThemeProvider theme={truckInYardTheme}>
      <div>
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList onChange={handleChange} aria-label="menu tabs">
                <Tab label="ETA RealTime" value="1" />
                <Tab label="ETA History" value="2" />
                <Tab
                  label={`Available Truck In Yard (${available})`}
                  value="3"
                />
                <Tab
                  label={`Not Available Truck In Yard (${unavailable})`}
                  value="4"
                />
              </TabList>
            </Box>
            <TabPanel value="1">
              <EtaBoard
                eta={eta}
                ma={ma}
                yard={data}
                handleOpen={handleOpen}
                viewDate={currentETA}
                changeViewDate={setCurrentETA}
              />
            </TabPanel>
            <TabPanel value="2">
              <EtaHistory />
            </TabPanel>
            <TabPanel value="3">
              <YardBoard
                data={data.filter(
                  (truck) =>
                    truck.dn[0].status === "discharged" ||
                    truck.dn[0].status === "closed"
                )}
                title="Available Truck In Yard"
                subtitle="Empty and ready for the next job"
                icon={CheckCircleIcon}
                accentColor="success.main"
                emptyLabel="No available trucks in yard right now"
                handleOpen={handleOpen}
              />
            </TabPanel>
            <TabPanel value="4">
              <YardBoard
                data={data.filter(
                  (truck) =>
                    !(
                      truck.dn[0].status === "discharged" ||
                      truck.dn[0].status === "closed"
                    )
                )}
                title="Not Available Truck In Yard"
                subtitle="Still holding cargo or mid-job"
                icon={ReportProblemIcon}
                accentColor="warning.main"
                emptyLabel="No unavailable trucks in yard right now"
                handleOpen={handleOpen}
              />
            </TabPanel>
          </TabContext>
        </Box>
        <TruckMapDialog
          open={openDialog}
          location={location}
          data={locationData}
          handleClose={handleClose}
        />
      </div>
    </ThemeProvider>
  )
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: theme.palette.action.selected,
  },
}))

const StatCard = ({ label, value, gradient }) => (
  <Paper
    elevation={0}
    sx={{
      p: 1,
      textAlign: "center",
      background: gradient,
      color: "white",
      borderRadius: 2,
    }}
  >
    <Typography variant="caption" sx={{ opacity: 0.9, fontSize: "0.7rem" }}>
      {label}
    </Typography>
    <Typography variant="body1" fontWeight="bold">
      {value}
    </Typography>
  </Paper>
)

const STAT_GRADIENTS = [
  "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
  "linear-gradient(135deg, #3a7bd5 0%, #00d2ff 100%)",
  "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
]

// departed_discharge_time marks when the truck actually became free; the DN's
// embedded date is only a fallback for older records that predate that field
const getIdleSince = (dn) => {
  const discharges = dn.discharges || []
  const departed = discharges[discharges.length - 1]?.departed_discharge_time
  return departed ? moment(departed) : moment(dn.dn.substring(0, 6), "YYMMDD")
}

const YardBoard = (props) => {
  const {
    data,
    title,
    subtitle,
    icon: HeaderIcon,
    accentColor,
    emptyLabel,
    handleOpen,
  } = props
  const [search, setSearch] = useState("")

  const sorted_data = [...data].sort((a, b) => a.dn[0].dn - b.dn[0].dn)

  const filtered_data = sorted_data.filter((truck) => {
    const q = search.trim().toLowerCase()
    if (!q) return true
    return (
      truck.truck_no.toLowerCase().includes(q) ||
      truck.dn[0].dn.toLowerCase().includes(q) ||
      (truck.dn[0].driver || "").toLowerCase().includes(q) ||
      (truck.dn[0].license_plate || "").toLowerCase().includes(q)
    )
  })

  const statusCounts = data.reduce((acc, truck) => {
    const status = truck.dn[0].status
    acc[status] = (acc[status] || 0) + 1
    return acc
  }, {})

  return (
    <Box>
      <Paper elevation={3} sx={{ p: 3, mb: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <HeaderIcon sx={{ fontSize: 40, color: accentColor }} />
            <Box>
              <Typography variant="h5" fontWeight="bold">
                {title} ({data.length})
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {subtitle}
              </Typography>
            </Box>
          </Box>
          <TextField
            size="small"
            placeholder="Search truck, plate, DN, driver"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            sx={{ minWidth: 260 }}
          />
        </Box>
      </Paper>

      {data.length > 0 && (
        <Grid container spacing={1} sx={{ mb: 3 }}>
          <Grid item xs={6} sm={3} md={3}>
            <StatCard
              label="Total"
              value={data.length}
              gradient={STAT_GRADIENTS[0]}
            />
          </Grid>
          {Object.entries(statusCounts)
            .sort((a, b) => b[1] - a[1])
            .slice(0, 3)
            .map(([status, count], index) => (
              <Grid item xs={6} sm={3} md={3} key={status}>
                <StatCard
                  label={status.toUpperCase()}
                  value={count}
                  gradient={STAT_GRADIENTS[index + 1]}
                />
              </Grid>
            ))}
        </Grid>
      )}

      {data.length === 0 && (
        <Paper elevation={0} sx={{ p: 5, textAlign: "center" }}>
          <Typography color="text.secondary">{emptyLabel}</Typography>
        </Paper>
      )}

      {data.length > 0 && (
        <TableContainer
          component={Paper}
          elevation={3}
          sx={{ borderRadius: 3 }}
        >
          <Table sx={{ minWidth: 900 }} size="small" aria-label="yard board table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Truck</StyledTableCell>
                <StyledTableCell>Latest DN</StyledTableCell>
                <StyledTableCell>Last Stop</StyledTableCell>
                <StyledTableCell>Driver</StyledTableCell>
                <StyledTableCell>Tel</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                <StyledTableCell>Idle</StyledTableCell>
                <StyledTableCell>GPS Update</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered_data.map((truck, index) => {
                const dn = truck.dn[0]
                const isAvailable =
                  dn.status === "discharged" || dn.status === "closed"
                const lastDischarge =
                  dn.discharges?.[dn.discharges.length - 1]?.discharge_name
                const gpsMinutesAgo = moment().diff(
                  moment(truck.updated_date),
                  "minute"
                )

                return (
                  <StyledTableRow key={truck.truck_no}>
                    <StyledTableCell>{index + 1}</StyledTableCell>
                    <StyledTableCell>
                      <Link
                        component="div"
                        underline="none"
                        onClick={() =>
                          handleOpen({
                            truck_no: truck.truck_no,
                            current_dn: dn.dn,
                          })
                        }
                      >
                        <Chip
                          label={truck.truck_no}
                          color="primary"
                          variant="outlined"
                          size="small"
                          sx={{ fontWeight: "bold", cursor: "pointer" }}
                        />
                      </Link>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ display: "block", mt: 0.5 }}
                      >
                        {dn.license_plate}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell>{dn.dn}</StyledTableCell>
                    <StyledTableCell>
                      <Tooltip title={lastDischarge || ""}>
                        <Typography
                          variant="body2"
                          sx={{
                            maxWidth: 200,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {lastDischarge || "-"}
                        </Typography>
                      </Tooltip>
                    </StyledTableCell>
                    <StyledTableCell>{dn.driver}</StyledTableCell>
                    <StyledTableCell>
                      {dn.tel ? (
                        <Link href={`tel:${dn.tel}`} underline="none">
                          <TelIcon
                            fontSize="small"
                            sx={{ verticalAlign: "middle", mr: 0.5 }}
                          />
                          {dn.tel}
                        </Link>
                      ) : (
                        "-"
                      )}
                    </StyledTableCell>
                    <StyledTableCell>
                      <Chip
                        label={dn.status.toUpperCase()}
                        color={isAvailable ? "success" : "warning"}
                        size="small"
                        sx={{ fontWeight: "bold" }}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      {getIdleSince(dn).fromNow(true)}
                    </StyledTableCell>
                    <StyledTableCell>
                      <Tooltip
                        title={moment(truck.updated_date).format(
                          "DD/MM/YY HH:mm"
                        )}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            color:
                              gpsMinutesAgo > 60
                                ? "error.main"
                                : "text.secondary",
                          }}
                        >
                          <GpsFixedIcon fontSize="inherit" />
                          <Typography variant="body2" color="inherit">
                            {moment(truck.updated_date).fromNow()}
                          </Typography>
                        </Box>
                      </Tooltip>
                    </StyledTableCell>
                  </StyledTableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  )
}

const EtaBoard = (props) => {
  const { eta, yard, ma, handleOpen, viewDate, changeViewDate } = props
  const [data, setData] = useState({ eta: [] })
  const [filter, setFilter] = useState([])

  useEffect(() => {
    var new_data = { eta: [], total_ma: 0 }
    var total_ma = 0
    var total_yard = 0
    var total_delay = 0
    var total_unconfirm = 0

    eta.forEach((truck) => {
      //ma status
      let ma_status =
        ma.findIndex((item) => item.truck_no === truck.truck_no) > -1
          ? true
          : false
      if (ma_status) {
        total_ma++
      }

      //yard status
      let yard_status =
        yard.findIndex((item) => item.truck_no === truck.truck_no) > -1
      if (yard_status) {
        total_yard++
      }

      //delay status
      let diff_min = moment().diff(moment(truck.eta), "minute") //moment(truck.eta).diff(moment(), 'minute')
      if (diff_min > 0 && !yard_status && !ma_status) {
        total_delay++
      }
      if (diff_min <= 0 && !yard_status && !ma_status) {
        total_unconfirm++
      }

      let new_row = {
        ...truck,
        ma_status,
        yard_status,
        delay_min: diff_min > 0 && !yard_status && !ma_status ? diff_min : 0,
      }

      new_data.eta.push(new_row)
    })

    new_data.total_ma = total_ma
    new_data.total_yard = total_yard
    new_data.total_delay = total_delay
    new_data.total_unconfirm = total_unconfirm

    setData({ ...new_data })
  }, [eta, yard, ma])

  const renderStat = (bgcolor, label, value, filter_code) => {
    return (
      <Grid item xs={12} md={6} lg={3}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            height: 120,
            bgcolor,
            color: "white",
          }}
        >
          <Grid container direction="row" justifyContent="space-between">
            <Grid item>
              <Typography variant="subtitle2" fontWeight="bold" component="div">
                {label}
              </Typography>
            </Grid>
            <Grid item>
              <FilterIcon
                fontSize="small"
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  let new_filter = [...filter]
                  let index = new_filter.findIndex((f) => f === filter_code)
                  if (index === -1) {
                    new_filter.push(filter_code)
                    setFilter(new_filter)
                  } else {
                    new_filter.splice(index, 1)
                    setFilter(new_filter)
                  }
                }}
              />
            </Grid>
          </Grid>

          <Typography
            variant="h4"
            component="div"
            align="right"
            fontWeight="bold"
          >
            {value}
          </Typography>
        </Paper>
      </Grid>
    )
  }

  const renderRow = (row) => {
    let row_color = row.yard_status
      ? "success.main"
      : row.ma_status
      ? "text.disabled"
      : row.delay_min > 0
      ? "error.main"
      : "#0288d1"

    let row_status = row.yard_status
      ? "YARD"
      : row.ma_status
      ? "MA"
      : row.delay_min > 0
      ? "DELAY"
      : "OTW"

    let known_yard_reason =
      row.yard_reason === "YARD_BSP" ||
      row.yard_reason === "YARD_MA" ||
      row.yard_reason === "NEW_DN_START"

    let diff_day = row.yard_time
      ? moment(moment(row.yard_time).format("YYYY-MM-DD")).diff(
          moment(moment(row.eta).format("YYYY-MM-DD")),
          "days"
        )
      : 0

    let ata_time = row.yard_time ? moment(row.yard_time).format("HH:mm") : ""

    let ata_reason_label =
      row.yard_time && !known_yard_reason && row.yard_reason
        ? row.yard_reason.replaceAll("_", " ")
        : ""

    let gps_diff = moment().diff(moment(row.gps_update), "minute")

    let route_code = [row.loading_point, ...(row.discharges || [])]
      .filter(Boolean)
      .join("-")

    let status_color =
      row.status === "discharged" || row.status === "closed"
        ? "success"
        : row.status === "loading" || row.status === "discharge"
        ? "warning"
        : "info"

    let isShow =
      filter.length === 0
        ? true
        : filter.findIndex((item) => item === row_status) >= 0
        ? true
        : false

    return (
      <TableRow
        key={row.truck_no}
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
          color: row_color,
          display: isShow ? "" : "none",
        }}
      >
        <StyledTableCell component="th" scope="row" sx={{ color: "inherit" }}>
          {moment(row.eta).format("DD-MM HH:mm")}
        </StyledTableCell>
        <StyledTableCell component="th" scope="row" sx={{ color: "inherit" }}>
          {ata_time}{" "}
          {diff_day !== 0
            ? diff_day > 0
              ? "(+" + diff_day + ")"
              : "(" + diff_day + ")"
            : ""}
          {ata_reason_label && (
            <Typography
              variant="caption"
              component="div"
              color="text.secondary"
            >
              {ata_reason_label}
            </Typography>
          )}
        </StyledTableCell>
        <StyledTableCell sx={{ color: "inherit", textDecoration: "none" }}>
          <Link
            component="div"
            underline="none"
            color="inherit"
            onClick={() => {
              handleOpen({ truck_no: row.truck_no, current_dn: row.dn })
            }}
          >
            <Chip
              label={row.truck_no}
              sx={{
                backgroundColor: row_color,
                color: "white",
                cursor: "pointer",
                fontWeight: 700,
              }}
            />
          </Link>
        </StyledTableCell>
        <StyledTableCell sx={{ color: "inherit" }}>{row.dn}</StyledTableCell>
        <StyledTableCell sx={{ color: "inherit" }}>
          <Tooltip title={route_code}>
            <Typography
              variant="body2"
              color="inherit"
              sx={{
                maxWidth: 160,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {route_code || "-"}
            </Typography>
          </Tooltip>
        </StyledTableCell>
        <StyledTableCell sx={{ color: "inherit" }}>
          {row.status ? (
            <Chip
              label={row.status.toUpperCase()}
              color={status_color}
              size="small"
              sx={{ fontWeight: "bold" }}
            />
          ) : (
            "-"
          )}
        </StyledTableCell>
        <StyledTableCell sx={{ color: "inherit" }}>{row.driver}</StyledTableCell>
        <StyledTableCell sx={{ color: "inherit" }}>
          <TelIcon fontSize="small" sx={{ verticalAlign: "middle", mr: 0.5 }} />
          {row.tel}
        </StyledTableCell>
        <StyledTableCell sx={{ color: "inherit" }}>
          <Tooltip
            title={
              (!(row.yard_status || row.ma_status) ? row.address : "") +
              (row.yard_status ? "YARDL" : "") +
              (row.ma_status ? "ซ่อมบำรุง" : "")
            }
          >
            <Typography
              variant="body2"
              color="inherit"
              sx={{
                maxWidth: 350,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {!(row.yard_status || row.ma_status) ? row.address : ""}
              {row.yard_status ? "YARDL" : ""}
              {row.ma_status ? "ซ่อมบำรุง" : ""}
            </Typography>
          </Tooltip>
        </StyledTableCell>
        <StyledTableCell sx={{ color: "inherit" }}>
          {gps_diff > 180
            ? "GPS Problem"
            : row.delay_min > 0 && ata_time === ""
            ? moment.duration(row.delay_min, "minute").humanize()
            : ""}
        </StyledTableCell>
      </TableRow>
    )
  }

  const renderFilter = () => {
    return (
      <Grid container direction="row" spacing={1}>
        <Grid item sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="body2" fontWeight="bold">
            Filter :
          </Typography>
        </Grid>
        {filter.length === 0 && (
          <Grid item>
            <Chip label="Show All" />
          </Grid>
        )}
        {filter.map((f) => {
          return (
            <Grid item>
              <Chip
                label={f}
                onDelete={() => {
                  let index = filter.findIndex((item) => item === f)
                  let new_filter = [...filter]

                  new_filter.splice(index, 1)
                  setFilter(new_filter)
                }}
              />
            </Grid>
          )
        })}
      </Grid>
    )
  }

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-end"
            spacing={1}
          >
            <Grid item>
              <Typography variant="h5" fontWeight="bold" gutterBottom>
                Estimate Time Arival
              </Typography>
              {renderFilter()}
            </Grid>
            <Grid item>
              <ButtonGroup
                variant="outlined"
                aria-label="outlined primary button group"
                sx={{ m: 1 }}
              >
                <Button
                  onClick={() => {
                    changeViewDate(
                      moment(
                        moment().utc().add(7, "hour").format("YYYY-MM-DD") +
                          "T10:00+07:00"
                      )
                    )
                  }}
                >
                  TODAY <br /> 10:00
                </Button>
                <Button
                  onClick={() => {
                    changeViewDate(
                      moment(
                        moment().utc().add(7, "hour").format("YYYY-MM-DD") +
                          "T18:00+07:00"
                      )
                    )
                  }}
                >
                  TODAY
                  <br /> 18:00
                </Button>
                <Button
                  onClick={() => {
                    changeViewDate(
                      moment(
                        moment()
                          .utc()
                          .add(7, "hour")
                          .add(1, "day")
                          .format("YYYY-MM-DD") + "T10:00+07:00"
                      )
                    )
                  }}
                >
                  TOMOROW <br />
                  10:00
                </Button>
                <Button
                  onClick={() => {
                    changeViewDate(
                      moment(
                        moment()
                          .utc()
                          .add(7, "hour")
                          .add(1, "day")
                          .format("YYYY-MM-DD") + "T18:00+07:00"
                      )
                    )
                  }}
                >
                  TOMOROW
                  <br /> 18:00
                </Button>
              </ButtonGroup>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePicker
                  label="Select Cut-Off Date Time"
                  value={viewDate}
                  onChange={changeViewDate}
                  renderInput={(params) => (
                    <TextField {...params} sx={{ m: 1 }} />
                  )}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </Grid>
        {renderStat("success.main", "In Yard", data.total_yard, "YARD")}
        {renderStat("info.main", "On The Way", data.total_unconfirm, "OTW")}
        {renderStat("error.main", "Delayed", data.total_delay, "DELAY")}
        {renderStat("text.disabled", "In MA Yard", data.total_ma, "MA")}

        <Grid item xs={12}>
          <TableContainer component={Paper} elevation={3} sx={{ borderRadius: 3 }}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  <StyledTableCell>ETA</StyledTableCell>
                  <StyledTableCell>ATA</StyledTableCell>
                  <StyledTableCell>Truck</StyledTableCell>
                  <StyledTableCell>Last DN</StyledTableCell>
                  <StyledTableCell>Route</StyledTableCell>
                  <StyledTableCell>Status</StyledTableCell>
                  <StyledTableCell>Driver</StyledTableCell>
                  <StyledTableCell>Tel</StyledTableCell>
                  <StyledTableCell>Current Location</StyledTableCell>
                  <StyledTableCell>Delay</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.eta
                  .sort((a, b) => moment(a.eta) - moment(b.eta))
                  .map((row) => renderRow(row))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </div>
  )
}

// const renderTruckCard = (truck) => {
//   return (
//     <Grid item key={truck.truck_no} xs={12} lg={3}>
//       <Paper
//         sx={{
//           p: 2,
//           display: "flex",
//           flexDirection: "column",
//           height: 120,
//         }}
//         elevation={3}
//       >
//         <Grid container>
//           <Grid item xs={6}>
//             <Typography
//               variant="h2"
//               component="div"
//               fontWeight="bold"
//               color="primary"
//             >
//               {truck.truck_no}
//             </Typography>
//           </Grid>
//           <Grid item xs={6}>
//             <Typography
//               variant="h5"
//               align="right"
//               component="div"
//               color="GrayText"
//             >
//               {truck.dn[0].dn}
//             </Typography>
//             <Typography
//               variant="h5"
//               align="right"
//               component="div"
//               color="Highlight"
//             >
//               {truck.dn[0].status === "discharged"
//                 ? moment(truck.dn[0].dn.substring(0, 6), "YYMMDD").fromNow()
//                 : truck.dn[0].status}
//             </Typography>
//           </Grid>
//           <Grid item xs={12}></Grid>
//         </Grid>
//       </Paper>
//     </Grid>
//   )
// }

export default TruckInYard
